import React from "react";
import PropTypes from "prop-types";
import { VehicleRequisitionList } from "./VehicleRequisitionList";
import { useTranslation } from "react-i18next";
import { Pagination } from "antd";

const VehicleRequisitionForm = ({
  isLoading,
  isFromAdmin = false,
  onAdd,
  onView,
  data,
  onAttachmentClicked,
  setCurrentYear,
  pagination,
  setPagination,
  resetPagination,
}) => {
  const { t } = useTranslation();

  const footerElement = (footerValue, totalPagination) => (
    <div style={{ textAlign: "right", marginRight: "10px" }}>
      <Pagination
        style={{ display: "inline-flex", paddingRight: 10 }}
        defaultCurrent={pagination.current}
        current={pagination.current}
        total={totalPagination}
        onChange={onChangePagination}
        showTotal={(total) =>
          t("general.total") + ` ${total} ` + t("general.records")
        }
        defaultPageSize={pagination.pageSize}
        pageSize={pagination.pageSize}
      />
      {t("general.total")} :{" "}
      <b style={{ color: "#0070cc" }}>{footerValue} KM</b>
    </div>
  );

  function onChangePagination(page, pageSize) {
    setPagination({
      current: page,
      minIndex: (page - 1) * pageSize,
      maxIndex: page * pageSize,
      pageSize: pageSize,
    });
  }

  return (
    <div>
      <VehicleRequisitionList
        isLoading={isLoading}
        isFromAdmin={isFromAdmin}
        data={data}
        onAdd={onAdd}
        onItemViewed={onView}
        isShowStatus={true}
        isMultipleAction={false}
        footerElement={footerElement}
        onAttachmentClicked={onAttachmentClicked}
        setCurrentYear={setCurrentYear}
        pagination={pagination}
        setPagination={setPagination}
        resetPagination={resetPagination}
      />
    </div>
  );
};

VehicleRequisitionForm.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isFromAdmin: PropTypes.bool,
  data: PropTypes.array.isRequired,
  onAdd: PropTypes.func,
  onView: PropTypes.func.isRequired,
  onAttachmentClicked: PropTypes.func.isRequired,
  setCurrentYear: PropTypes.func.isRequired,
  pagination: PropTypes.object,
  setPagination: PropTypes.func,
  resetPagination: PropTypes.func,
};

export default VehicleRequisitionForm;
